import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// clsx handles conditionals, twMerge resolves Tailwind conflicts so a later
// `px-2` actually beats an earlier `px-4` instead of both landing in class.
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
